// rules.jsx
import React, { useEffect, useState } from 'react';
import './rules.css';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { selectAdminToken } from '../../admin/sessionSlice';
import { setBackButtonUrl } from '../uiSlice';
import { toSentenceCase } from '../../utils/sentenceCase';

function UserRules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status: themeStatus, data: themeData } = useSelector(
    (state) => state.theme
  );
  const { status, user, error } = useSelector((state) => state.auth);
  const [redirect, setRedirect] = useState("/avatar");
  const adminToken = useSelector(selectAdminToken);
  const isMobile = window.innerWidth <= 768;
  const rulesBgAsset =
    (isMobile ? themeData?.background_mob : themeData?.background_desk) ||
    themeData?.bg_image ||
    "";

  useEffect(() => {
    if (!themeData) return;

    setRedirect("/avatar");
  }, [themeData]);

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [status, user]);

  useEffect(() => {
    const prevBodyOverflow = document.body.style.overflow;
    const prevHtmlOverflow = document.documentElement.style.overflow;
    const prevBodyOverscroll = document.body.style.overscrollBehavior;
    const prevHtmlOverscroll = document.documentElement.style.overscrollBehavior;

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    document.body.style.overscrollBehavior = "none";
    document.documentElement.style.overscrollBehavior = "none";

    return () => {
      document.body.style.overflow = prevBodyOverflow;
      document.documentElement.style.overflow = prevHtmlOverflow;
      document.body.style.overscrollBehavior = prevBodyOverscroll;
      document.documentElement.style.overscrollBehavior = prevHtmlOverscroll;
    };
  }, []);

  useEffect(() => {
    const prevBodyBgImage = document.body.style.backgroundImage;
    const prevBodyBgPosition = document.body.style.backgroundPosition;
    const prevBodyBgRepeat = document.body.style.backgroundRepeat;
    const prevBodyBgSize = document.body.style.backgroundSize;

    if (rulesBgAsset) {
      const rulesBgUrl = `${process.env.REACT_APP_S3_PATH + rulesBgAsset}`;
      document.body.style.backgroundImage = `url(${rulesBgUrl})`;
      document.body.style.backgroundPosition = "center";
      document.body.style.backgroundRepeat = "no-repeat";
      document.body.style.backgroundSize = "100% 100%";
    }

    return () => {
      document.body.style.backgroundImage = prevBodyBgImage;
      document.body.style.backgroundPosition = prevBodyBgPosition;
      document.body.style.backgroundRepeat = prevBodyBgRepeat;
      document.body.style.backgroundSize = prevBodyBgSize;
    };
  }, [rulesBgAsset]);

  const handleNextClick = (e) => {
    e.preventDefault();
    navigate(redirect);
  };


  if (!themeData) {
    return (
      <div className='quiz-loader-container'>
        <div className="quiz-loader"></div>
      </div>
    );
  }

  const publicUrl = process.env.PUBLIC_URL || "";
  const cornerStars = ["c1.png", "c2.png", "c3.png", "c4.png"];

  return (
    <div className="user-rules-page">
      <div className="user-rules-container">
        <div className={`user-rules-star user-rules-star--tl`}>
          <img src={`${publicUrl}/img/${cornerStars[0]}`} alt="" />
        </div>
        <div className={`user-rules-star user-rules-star--tr`}>
          <img src={`${publicUrl}/img/${cornerStars[1]}`} alt="" />
        </div>
        <div className={`user-rules-star user-rules-star--bl`}>
          <img src={`${publicUrl}/img/${cornerStars[2]}`} alt="" />
        </div>
        <div className={`user-rules-star user-rules-star--br`}>
          <img src={`${publicUrl}/img/${cornerStars[3]}`} alt="" />
        </div>

        <div
          className="user-rules-card"
          style={{
            backgroundImage: `url(${publicUrl}/img/box.png)`,
          }}
        >
          <div className="user-rules-title-wrap">
            {themeData?.main_title && (
              <div className="user-rules-big-title" style={{ color: themeData?.text_color }}>{toSentenceCase(themeData.main_title)}</div>
            )}
            {themeData?.landing_page_title && (
              <div className="user-rules-subline" style={{ color: themeData?.text_color }}>{toSentenceCase(themeData.landing_page_title)}</div>
            )}
          </div>

          <ul className="user-rules-list">
            {
              themeData?.rules?.map((rule, index) => (
                <li key={index}>
                  <span className="user-rule-check" aria-hidden="true">✓</span>
                  <span className="user-rule-text" style={{ color: themeData?.text_color }}>{toSentenceCase(rule)}</span>
                </li>
              ))
            }
          </ul>
        </div>

        <div className="user-rules-upload-wrap">
          <div className="user-rules-upload-title" style={{ color: themeData?.text_color }}>Upload your idol moment</div>
          <div className="user-rules-upload-subline" style={{ color: themeData?.text_color }}>
            Drop in a clear selfie and get ready for your transformation into a K-pop superstar
          </div>

          <div className="user-rules-upload-buttons">
            <button
              className="user-rules-upload-btn"
              onClick={handleNextClick}
              aria-label="Click a selfie"
            >
              <img src={`${publicUrl}/img/camera.png`} alt="" className="user-rules-upload-icon" />
            </button>
            <span className="user-rules-upload-or">or</span>
            <button
              className="user-rules-upload-btn"
              onClick={handleNextClick}
              aria-label="Upload picture"
            >
              <img src={`${publicUrl}/img/gallery.png`} alt="" className="user-rules-upload-icon" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserRules;